import { useCallback } from 'react';
import { showSuccess } from '../utils/toastHelpers';

/**
 * Hook that returns an exportCSV function.
 * columns: [{ key, header, format? }]
 */
export function useCSVExport() {
  const exportCSV = useCallback((data, columns, filename) => {
    const delimiter = ';';
    const headers = columns.map((c) => c.header);
    const rows = data.map((item) =>
      columns.map((c) => {
        const raw = c.format ? c.format(item) : item[c.key];
        const val = raw == null ? '' : String(raw);
        // Escape values containing delimiter, quotes, or newlines
        return val.includes(delimiter) || val.includes('"') || val.includes('\n') || val.includes('\r')
          ? `"${val.replace(/"/g, '""')}"`
          : val;
      })
    );

    // "sep=;" helps Excel respect delimiter in locales where comma is decimal separator.
    const csvContent = ['sep=' + delimiter, headers.join(delimiter), ...rows.map((r) => r.join(delimiter))].join('\r\n');
    const csvBytes = new TextEncoder().encode(csvContent);
    const utf8Bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    const blob = new Blob([utf8Bom, csvBytes], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    showSuccess('Успешно експортирано', 'Податоците се успешно експортирани во CSV.');
  }, []);

  return { exportCSV };
}
